import {
  REQUEST_LOGIN,
  REQUEST_LOGIN_FAILED,
  REQUEST_LOGOUT,
  REQUEST_LOGOUT_FAILED,
  VALIDATE_AUTH,
  VERIFY_NEW_ACCOUNT,
} from '../constants/index';
import { call, put, takeEvery } from 'redux-saga/effects';
import { requestLoginSuccess, requestLogoutSuccess } from '../actions/authActions';
import authErrors from '../../constants/authErrors';
import { clearChats } from '../actions/chatsActions';
import config from '../../shared/config';
import generateAuthError from '../../services/error.parser';
const { loginUrl, userDataUrl, validateUrl, tokenUrl } = config;

function* verifyAccount(action) {
  const restoreKey = action.payload.split('key=')[1].split('&')[0];
  try {
    const isVerified = yield call(fetch, tokenUrl, {
      body: JSON.stringify({
        key: restoreKey,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    const isVerifiedParsed = yield call([isVerified, 'json']);
    if (isVerified.status === 200) {
      yield put({ type: VALIDATE_AUTH });
    } else {
      throw isVerifiedParsed;
    }
  } catch (error) {
    console.error('verifyAccount error', error);
    yield put({
      payload: generateAuthError({ error, errors: authErrors, unhandledErrorMessage: 'verifying error' }),
      type: REQUEST_LOGIN_FAILED,
    });
  }
}

function* validateAuth() {
  try {
    const validateResponse = yield call(fetch, validateUrl, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      method: 'GET',
    });
    if (validateResponse.ok) {
      const {
        userStatus: { id },
      } = yield call((data) => data, validateResponse.json());
      yield put(requestLoginSuccess({ userId: id }));
    } else {
      yield put(requestLogoutSuccess());
    }
  } catch (error) {
    console.error('validateAuth error', error);
    yield put(requestLogoutSuccess());
    yield put({
      payload: generateAuthError({ error, errors: authErrors, unhandledErrorMessage: 'validateAuth error' }),
      type: REQUEST_LOGIN_FAILED,
    });
  }
}

function* requestLoginHandler(action) {
  const { email, password } = action.payload;
  try {
    const loginResponse = yield call(fetch, loginUrl, {
      body: JSON.stringify({
        password: password,
        socialLogin: email,
        userId: email,
        username: email,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    if (loginResponse.status === 200) {
      const userData = yield call(fetch, userDataUrl, { credentials: 'include' });
      const parsedData = yield call((data) => data, userData.json());
      yield put(requestLoginSuccess({ userId: parsedData.id }));
    } else {
      const parsed = yield call([loginResponse, 'json']);
      throw parsed;
    }
  } catch (error) {
    console.error('auth error', error);
    yield put({
      payload: generateAuthError({ error, errors: authErrors }),
      type: REQUEST_LOGIN_FAILED,
    });
  }
}

function* finishLogout() {
  yield put(requestLogoutSuccess());
  yield put(clearChats());
  localStorage.removeItem('accessToken');
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage('logout');
  }
}

function* requestLogoutHandler() {
  try {
    yield call(fetch, config.logoutUrl, {
      credentials: 'include',
    });
    yield call(finishLogout);
  } catch (error) {
    yield put({
      message: (error.response && error.response.status) || error.message,
      type: REQUEST_LOGOUT_FAILED,
    });
  }
}

export default function* fetchUserWatcher() {
  yield takeEvery(REQUEST_LOGOUT, requestLogoutHandler);
  yield takeEvery(REQUEST_LOGIN, requestLoginHandler);
  yield takeEvery(VALIDATE_AUTH, validateAuth);
  yield takeEvery(VERIFY_NEW_ACCOUNT, verifyAccount);
}
